import {
  PI_DATA_REQUEST,
  PI_DATA_SUCCESS,
  PI_DATA_FAIL,
} from '../constants/proposedInsuredConstants';

export const proposedInsuredReducer = (state = { formData: [] }, action) => {
  switch (action.type) {
    case PI_DATA_REQUEST:
      return { loading: true, formData: [] };
    case PI_DATA_SUCCESS:
      return { loading: false, formData: action.payload };
    case PI_DATA_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
